import React from "react";
import styled from 'styled-components';
import { AvFeedback, AvForm, AvGroup, AvInput } from "availity-reactstrap-validation";
import { Col, Row } from "reactstrap";
const StyledCol = styled(Col)`
  padding: 0 !important;
`;
const StyledAvForm = styled(AvForm)`
  width: 100%;
`;
const StyledAvGroup = styled(AvGroup)`
  margin-bottom: 0 !important;
`;
const InlineToggleActionForm = /*#__PURE__*/React.memo(({
  placeholder,
  text = "",
  children,
  closeForm,
  onChange,
  required = false
}) => {
  return /*#__PURE__*/React.createElement(StyledAvForm, {
    onValidSubmit: () => {
      console.log('submit');
    },
    autoComplete: 'off'
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 10
  }, /*#__PURE__*/React.createElement(StyledAvGroup, null, /*#__PURE__*/React.createElement(AvInput, {
    className: 'activated-input',
    type: 'text',
    name: "name",
    id: 'name',
    placeholder: placeholder,
    value: text,
    onBlur: closeForm,
    onFocus: e => e.target.select(),
    onChange: e => onChange(e),
    autoFocus: true,
    required: required
  }), /*#__PURE__*/React.createElement(AvFeedback, null, 'Name is required.'))), /*#__PURE__*/React.createElement(StyledCol, {
    xs: 2
  }, children)));
});
export default InlineToggleActionForm;